export const getECID = () =>
  _satellite?.getVisitorId?.()?.getMarketingCloudVisitorID?.() || undefined;
